/** Parse a JSON response, or null when the body is not JSON. Shared by the
 *  wallet cards, each of which reads a different endpoint. */
export async function safeJsonParse<T>(response: Response): Promise<T | null> {
  const contentType = response.headers.get('content-type');
  if (!contentType?.includes('application/json')) {
    console.error('Response is not JSON:', contentType);
    return null;
  }
  try {
    return await response.json();
  } catch {
    console.error('Failed to parse JSON response');
    return null;
  }
}
